/**
 * Pin / unpin conversations in the Leads inbox.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import {
  pinConversation,
  unpinConversation,
} from "../services/conversationListService.js";
import { conversationListQueryKey } from "./useConversationList.js";

export function useConversationPin() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ channelId, pin }) => {
      if (!channelId) {
        throw new Error("Missing conversation phone");
      }
      if (pin) {
        return pinConversation(channelId);
      }
      return unpinConversation(channelId);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["conversation-list"] });
      message.success(
        variables.pin ? "Conversation pinned" : "Conversation unpinned"
      );
    },
    onError: (error) => {
      const limitReached = error?.code === "PIN_LIMIT_REACHED";
      message.error(
        error?.message ||
          (limitReached
            ? "Pin limit reached"
            : "Could not update pin")
      );
    },
  });

  const togglePin = (record) => {
    const channelId = record?.customerPhone;
    if (!channelId || mutation.isPending) return;
    mutation.mutate({ channelId, pin: !record?.isPinned });
  };

  return {
    togglePin,
    isPinning: mutation.isPending,
    pinningChannelId: mutation.isPending
      ? mutation.variables?.channelId
      : null,
  };
}

export { conversationListQueryKey };
